import { persistStore, persistReducer } from 'redux-persist'
import { combineReducers, configureStore } from '@reduxjs/toolkit'
import storageSession from 'redux-persist/lib/storage/session';
import authReducer from './slices/authSlice'
import propertyReducer from './slices/propertySlice'
import adminControlReducer from './slices/adminControlSlice'
import clientReducer from './slices/clientSlice'
import regionReducer from './slices/regionSlice'
import cityReducer from './slices/citySlice'
import cleanersReducer from './slices/cleanersSlice'
import OverViewReducer from './slices/overviewSlice'
import TemplatesReducer from './slices/templateSlice'
import PaymentReducer from './slices/paymentSlice'
import CalendarReducer from './slices/calendarSlice'
import ReportReducer from './slices/reportSlice'
import PricingTableReducer from './slices/pricingTableSlice'
import ChatReducer from './slices/chatSlice'
import LogReducer from './slices/logSlice'
import dashboardReducer from './slices/dashboardSlice'
import cleanerReportReducer from './slices/cleanerReportSlice'
import notificationReducer from './slices/notificationSlice'
import couponReducer from './slices/couponsSlice'
import SupervisorNotesSlice from './slices/supervisorSlice'
import hostTaskReducer from './slices/hostTaskSlice'

const authPersistConfig = {
  key: 'userInfo',
  storage:storageSession,
  whitelist: ['user']
}

const reducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  property: propertyReducer,
  adminControl: adminControlReducer,
  client: clientReducer,
  region: regionReducer,
  city: cityReducer,
  cleaners: cleanersReducer,
  overView: OverViewReducer,
  templates: TemplatesReducer,
  payment: PaymentReducer,
  calendar: CalendarReducer,
  report: ReportReducer,
  pricingTable: PricingTableReducer,
  chat: ChatReducer,
  log: LogReducer,
  dashboard: dashboardReducer,
  cleanerReport: cleanerReportReducer,
  notification: notificationReducer,
  coupons: couponReducer,
  notes: SupervisorNotesSlice,
  hostTask: hostTaskReducer
})

const rootReducer = (state, action) => {
  if (action.type === 'auth/logout/fulfilled') {
    return { state, auth: { isLoading: false, user: null, error: null } }
  }
  return reducer(state, action)
}

export const store = configureStore({
  reducer: rootReducer
})

export const persistor = persistStore(store)
